import { SHOW_TASK_ASSIGNEE_ROLES } from '../taskBoardConfig';
import { taskDesignationLabel } from '../taskUtils';
import { useTaskTranslation } from '../hooks/useTaskTranslation';
import { designationByRoleId } from '../../../constants/designations';
import { hasValidAssigneeIds, TaskAssigneeSelection } from '../hooks/useTaskAssigneeSelection';
import { TaskPersonPicker } from './TaskPersonPicker';

interface TaskAssigneePickerProps {
  selection: TaskAssigneeSelection;
  disabled?: boolean;
  clearLabel?: string;
  onSelectionChange?: () => void;
}

export const TaskAssigneePicker = ({
  selection,
  disabled,
  clearLabel,
  onSelectionChange,
}: TaskAssigneePickerProps) => {
  const { translations } = useTaskTranslation();
  return (
    <TaskPersonPicker
      label={translations('task_board.assigned_to')}
      searchLabel={translations('task_board.search_assignees')}
      searchPlaceholder={translations('task_board.search_by_name_or_person_id')}
      listLabel={translations('task_board.choose_an_assignee')}
      showDetails={SHOW_TASK_ASSIGNEE_ROLES}
      search={selection.search}
      onSearchChange={selection.setSearch}
      options={
        selection.ready
          ? selection.filteredOptions.map(({ person, key }) => ({
              key,
              name: [person.person_firstname, person.person_lastname].filter(Boolean).join(' '),
              details: taskDesignationLabel(
                designationByRoleId(person.role_id) || person.role_name?.trim() || '',
                translations
              ),
              disabled: !hasValidAssigneeIds(person),
            }))
          : []
      }
      selectedKey={selection.selectedKey}
      selectedName={
        selection.selectedPerson &&
        [selection.selectedPerson.person_firstname, selection.selectedPerson.person_lastname]
          .filter(Boolean)
          .join(' ')
      }
      onSelect={(key) => {
        selection.selectPerson(key);
        onSelectionChange?.();
      }}
      onClear={() => {
        selection.clearSelection();
        onSelectionChange?.();
      }}
      clearLabel={clearLabel ?? translations('task_board.clear_assignee')}
      disabled={disabled}
      loading={selection.pending}
      error={selection.error}
      onRetry={selection.retryPersons}
      emptyMessage={
        selection.hasPersons
          ? translations('task_board.no_assignees_match_your_search')
          : translations('task_board.no_assignees_available')
      }
    />
  );
};
